import { useEffect, useMemo } from 'react';
import throttle from 'lodash.throttle';
import Log from '@deephaven/log';
var UPDATE_DELAY = 150;
var ROW_BUFFER_PAGES = 3;
var log = Log.module('CommandHistoryViewportUpdater');
function CommandHistoryViewportUpdater(_ref) {
  var table = _ref.table,
    columns = _ref.columns,
    _ref$top = _ref.top,
    top = _ref$top === void 0 ? 0 : _ref$top,
    _ref$bottom = _ref.bottom,
    bottom = _ref$bottom === void 0 ? 0 : _ref$bottom,
    search = _ref.search,
    _ref$isReversed = _ref.isReversed,
    isReversed = _ref$isReversed === void 0 ? false : _ref$isReversed,
    onUpdate = _ref.onUpdate;
  var throttledUpdateViewport = useMemo(() => throttle(viewport => {
    var viewHeight = viewport.bottom - viewport.top;
    var bufferedTop = Math.max(0, viewport.top - viewHeight * ROW_BUFFER_PAGES);
    var bufferedBottom = viewport.bottom + viewHeight * ROW_BUFFER_PAGES;
    table.setViewport({
      top: bufferedTop,
      bottom: bufferedBottom,
      columns: viewport.columns
    });
  }, UPDATE_DELAY), [table]);
  useEffect(function updateTableAndReturnCleanup() {
    var cleanup = table.onUpdate(viewportData => {
      var _viewportData$items, _viewportData$offset;
      onUpdate({
        items: (_viewportData$items = viewportData.items) !== null && _viewportData$items !== void 0 ? _viewportData$items : [],
        offset: (_viewportData$offset = viewportData.offset) !== null && _viewportData$offset !== void 0 ? _viewportData$offset : 0
      });
    });
    return () => {
      log.debug('onUpdate cleanup');
      cleanup();
    };
  }, [table, onUpdate]);
  useEffect(function setSearchText() {
    table.setSearch(search !== null && search !== void 0 ? search : '');
  }, [table, search]);
  useEffect(function updateViewport() {
    throttledUpdateViewport({
      top,
      bottom,
      columns
    });
  }, [throttledUpdateViewport, top, bottom, columns, search, isReversed]);
  useEffect(() => () => {
    log.debug2('Cancel throttledUpdateViewport');
    throttledUpdateViewport.cancel();
  }, [throttledUpdateViewport]);
  return null;
}
export default CommandHistoryViewportUpdater;
//# sourceMappingURL=CommandHistoryViewportUpdater.js.map